<!-- <template>
    <router-link :to="brand.url" class="c-brandTile">
        <span>
            <img :src="brand.logo" :alt="brand.name">
        </span>
    </router-link>
</template>
<script>
export default {
    props:['brand']
}
</script> -->

<template>
    <div class="c-brandTile" @click="handleClick">
      <span>
        <img :src="brand.logo" :alt="brand.name">
      </span>
    </div>
  </template>
  
  <script>
  export default {
    props: ['brand'],
    methods: {
      handleClick() {
        if (this.brand.url.startsWith('http')) {
          window.location.href = this.brand.url; // For external URLs
        } else {
          this.$router.push(this.brand.url); // For internal navigation
        }
      },
    },
  }
  </script>

<style lang="scss">
    .c-brandTile{
        transition: all ease-in-out 300ms;
        padding: 1rem;
        cursor: pointer;
        display:flex;
        justify-content: center;
        align-items: center;
        width: calc(100%/2);
        margin-bottom:2rem;
        @media(min-width: 960px){
            width: calc(100%/3);
        }
        &:hover{
            transform: scale(1.1);
            box-shadow: 0 0 8px 3px #d4d4d4;
        }
        img{
            width: 100%;
            @media(min-width: 960px){
                max-height: 133px;
                max-width: 233px;
                // width: auto;
            }
        }
    }
</style>

<Custom Blocks> 
<div>
</div>
</Custom>